import { useRouter } from 'next/router'
import React, { useCallback, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import clsx from 'clsx'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'
import { historyUtils } from '@wartek-id/toolbox-helper'

import { CustomErrorFallback } from 'components/ErrorBoundary'
import { JenjangUnmatched } from 'api/microlearning/useAPITopics'
import PelatihanErrorFallback from 'app/PelatihanMandiriPage/components/PelatihanErrorFallback'
import TopicDetails from 'app/PelatihanMandiriPage/pages/TopicDetails'
import { NotFoundError } from 'utils/customError'
import useShowSocialDrawer from 'app/PelatihanMandiriPage/hooks/useShowSocialDrawer'
import { shouldHideNav } from 'app/PelatihanMandiriPage/helper'
import { usePelatihanMandiriDesktopDetailView } from 'app/PelatihanMandiriPage/hooks/usePelatihanMandiriDesktopDetailView'

const TopikPage = () => {
  const isDesktopDetail = usePelatihanMandiriDesktopDetailView()
  const router = useRouter()

  const [shareText, setShareText] = useState('')
  const { triggerShareDialog, Drawer } = useShowSocialDrawer({
    drawerTitle: 'Bagikan Topik',
    shareText: shareText,
  })
  const handlePageLoaded = useCallback((topicName?: string) => {
    setShareText(
      `Ibu/Bapak Guru, ${
        !!topicName ? `ini topik ${topicName}` : 'ada topik pelatihan'
      } di platform RGTK. Silakan cek di tautan berikut: ${
        window.location.href
      }`
    )
  }, [])
  return (
    <ErrorBoundary
      resetKeys={[router.asPath]}
      FallbackComponent={({ error, resetErrorBoundary }) => {
        if (
          error instanceof NotFoundError ||
          error instanceof JenjangUnmatched
        ) {
          return (
            <PelatihanErrorFallback
              error={error}
              resetErrorBoundary={resetErrorBoundary}
            />
          )
        } else {
          return (
            <CustomErrorFallback
              error={error}
              resetErrorBoundary={resetErrorBoundary}
            />
          )
        }
      }}
    >
      {!isDesktopDetail && !shouldHideNav() && (
        <HeaderBar fixed borderless className="z-10">
          <HeaderBarLeftAction
            icon={
              <Icon as="i" color="default">
                arrow_back
              </Icon>
            }
            onClick={() => historyUtils.backToApp(router.back)}
          />
          <HeaderBarRightAction onClick={triggerShareDialog}>
            <Icon>share</Icon>
          </HeaderBarRightAction>
        </HeaderBar>
      )}
      <div
        className={clsx(!isDesktopDetail && !shouldHideNav() && 'mt-[54px]')}
      >
        <TopicDetails
          onPageLoaded={handlePageLoaded}
          onShareClick={triggerShareDialog}
          isDesktop={isDesktopDetail}
        />
      </div>
      <Drawer />
    </ErrorBoundary>
  )
}

TopikPage.layoutOpts = {
  hasHeader: false,
  className: 'bg-gray-10',
  enableDesktopLayout: true,
}

export default TopikPage
